module.exports = __webpack_public_path__ + "media/images/svgs/shorts-icon-02f887ae2b29ac6fa98b16ddc5fc7734.svg";